<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-10-14 14:56:20
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2026-09-09 15:29:59
 * @FilePath: \vue-app-console\src\views\Tenant\AddTenant.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE   
-->
<template>
    <div>
        <a-modal 
            v-model:open="props.visible"
            :title="$t('base.add')"
            :width="1000"
            centered
            :maskClosable="false"
            :confirmLoading="btn_loading"
            :destroyOnClose="true"
            :footer="null"
            @cancel="handleCancel"
        >
            <div class="steps_container">
                <a-steps :current="current" :items="items"></a-steps>
                <div class="steps_content_container">
                    <!-- 租户信息 -->
                    <div class="steps_content" v-if="current == 0">
                        <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.tenant_name') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.tenant_name" maxlength="50" />
                                </div>
                            </div>
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.tenant_code') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.tenant_code" maxlength="40"/>
                                </div>
                            </div>
                            <div class="form_item_right" >   
                                <div class="form_item_label">{{ $t('tenant.app_id') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.app_id" maxlength="50"/>
                                </div>
                            </div>
                        </div>
                        <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.domain_name') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.domain_name" maxlength="50"/>
                                </div>
                            </div>
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.project_no') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.project_no" maxlength="50"/>
                                </div>
                            </div>
                            <div class="form_item_right" v-if="!props.isEdit">   
                                <div class="form_item_label">{{ $t('tenant.jwt_secret') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.jwt_secret" maxlength="50"/>
                                </div>
                            </div>
                        </div>   
                        <a-divider />
                        <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.picture_path') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.picture_path" maxlength="100"/>
                                </div>
                            </div>
                            <div class="form_item_right">   
                                <div class="form_item_label">{{ $t('tenant.file_path') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.file_path" maxlength="100"/>
                                </div>
                            </div>
                        </div>
                        <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.avatar_path') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.avatar_path" maxlength="100"/>
                                </div>
                            </div>
                            <div class="form_item_right">   
                                <div class="form_item_label">{{ $t('tenant.vali_user_path') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.vali_user_path" maxlength="100"/>
                                </div>
                            </div>
                        </div>
                        <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.fault_font_color') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.fault_font_color" maxlength="20"/>
                                </div>
                            </div>
                            <div class="form_item_right">   
                                <div class="form_item_label">{{ $t('tenant.fault_background_color') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.fault_background_color" maxlength="20"/>
                                </div>
                            </div>
                        </div>
                        <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.activate_mileage_type') }}</div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant.activate_mileage_type"
                                        :options="activateMileageOptions"   
                                        style="width: 100%"
                                    ></a-select>
                                </div>
                            </div>
                            <div class="form_item_right">   
                                <div class="form_item_label">{{ $t('tenant.warranty_period') }}</div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.warranty_period" maxlength="20"/>
                                </div>
                            </div>
                        </div>
                        <a-divider />
                        <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.firmware_path') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.firmware_path" maxlength="100"/>
                                </div>
                            </div>
                        </div>
                        <div class="form_item">
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.del_user_path') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.del_user_path" maxlength="100"/>
                                </div>
                            </div>
                        </div>
                        <div class="form_item">
                            <div class="form_item_right">   
                                <div class="form_item_label">{{ $t('tenant.fault_path') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.fault_path" maxlength="100"/>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.firmware_path') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.firmware_path" />
                                </div>
                            </div>
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.del_user_path') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.del_user_path" />
                                </div>
                            </div>
                            <div class="form_item_right">   
                                <div class="form_item_label">{{ $t('tenant.fault_path') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.fault_path" />
                                </div>
                            </div>
                        </div> -->
                        <!-- <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.fault_font_color') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.fault_font_color" maxlength="20"/>
                                </div>
                            </div>
                            <div class="form_item_right">   
                                <div class="form_item_label">{{ $t('tenant.fault_background_color') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant.fault_background_color" maxlength="20"/>
                                </div>
                            </div>
                        </div> -->
                        <a-divider />
                        <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.logo_icon') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-upload 
                                        v-model:file-list="logoIconList"
                                        accept=".jpg,.jpeg,.png,.webp"
                                        action="/"
                                        :headers="headers"
                                        :maxCount="1"
                                        list-type="picture-card"
                                        :customRequest="customRequest"
                                        @change="(obj)=>uploadChange('logoIcon', obj)"
                                    >
                                        <div v-if="logoIconList.length < 1">
                                            <PlusOutlined />
                                            <div style="margin-top: 8px">{{ $t('base.upload') }}</div>
                                        </div>
                                    </a-upload>
                                </div>
                            </div>
                            <div class="form_item_right">   
                                <div class="form_item_label">{{ $t('tenant.small_logo_icon') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-upload 
                                        v-model:file-list="smallLogoIconList"
                                        accept=".jpg,.jpeg,.png,.webp"
                                        action="/"
                                        :headers="headers"
                                        :maxCount="1"
                                        list-type="picture-card"
                                        :customRequest="customRequest"
                                        @change="(file, fileList)=>uploadChange('smallLogoIcon', file, fileList)"
                                    >
                                        <div v-if="smallLogoIconList.length < 1">
                                            <PlusOutlined />
                                            <div style="margin-top: 8px">{{ $t('base.upload') }}</div>
                                        </div>
                                    </a-upload>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 邮箱信息 -->
                    <div class="steps_content" v-if="current == 1">   
                        <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.mail_host') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant_mail.mail_host" maxlength="50" />
                                </div>
                            </div>
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.mail_port') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant_mail.mail_port" maxlength="10"/>
                                </div>
                            </div>
                            <div class="form_item_right">
                                <div class="form_item_label">{{ $t('tenant.mail_protocol') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant_mail.mail_protocol" maxlength="40" />
                                </div> 
                            </div>
                        </div>
                        <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.mail_username') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant_mail.mail_username" maxlength="50" />
                                </div>
                            </div>
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.mail_password') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant_mail.mail_password" maxlength="50"/>
                                </div>
                            </div>
                            <div class="form_item_right"> 
                                <div class="form_item_label">{{ $t('tenant.default_encoding') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-input v-model:value="addFormData.tenant_mail.default_encoding" maxlength="40"/>
                                </div>
                            </div>
                        </div>
                        <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.mail_debug') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_mail.mail_debug" 
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.mail_starttls') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_mail.mail_starttls"
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                        </div>
                        <div class="form_item">
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.mail_ssl') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_mail.mail_ssl"
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                            <div class="form_item_right">   
                                <div class="form_item_label">{{ $t('tenant.mail_auth') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_mail.mail_auth"
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.mail_debug') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_mail.mail_debug" 
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.mail_starttls') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_mail.mail_starttls"
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.mail_ssl') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_mail.mail_ssl"
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                            <div class="form_item_right">   
                                <div class="form_item_label">{{ $t('tenant.mail_auth') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_mail.mail_auth"
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                        </div> -->
                        <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.mail_head_icon') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-upload 
                                        v-model:file-list="mailHeadIconList"
                                        accept=".jpg,.jpeg,.png,.webp"
                                        action="/"
                                        :headers="headers"
                                        :maxCount="1"
                                        list-type="picture-card"
                                        :customRequest="customRequest"
                                        @change="(obj)=>uploadChange('mailHeadIcon', obj)"
                                    >
                                        <div v-if="mailHeadIconList.length < 1">
                                            <PlusOutlined />
                                            <div style="margin-top: 8px">{{ $t('base.upload') }}</div>
                                        </div>
                                    </a-upload>
                                </div>
                            </div>
                            <div class="form_item_right">
                                <div class="form_item_label">{{ $t('tenant.mail_footer_icon') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-upload 
                                        v-model:file-list="mailFooterIconList"
                                        accept=".jpg,.jpeg,.png,.webp"
                                        action="/"
                                        :headers="headers"
                                        :maxCount="1"
                                        list-type="picture-card"
                                        :customRequest="customRequest"
                                        @change="(obj)=>uploadChange('mailFooterIcon', obj)"
                                    >
                                        <div v-if="mailFooterIconList.length < 1">
                                            <PlusOutlined />
                                            <div style="margin-top: 8px">{{ $t('base.upload') }}</div>
                                        </div>
                                    </a-upload>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 部件权限 -->
                    <div class="steps_content" v-if="current == 2">   
                        <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.require_hardware_version') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_part_permission.require_hardware_version" 
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.require_software_version') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_part_permission.require_software_version"
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                        </div>
                        <div class="form_item">
                            <div class="form_item_right">   
                                <div class="form_item_label">{{ $t('tenant.require_company_id') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_part_permission.require_company_id"
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.require_project_no') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_part_permission.require_project_no" 
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                        </div>
                        <div class="form_item">
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.check_display_theft_prevention') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_part_permission.check_display_theft_prevention"
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                            <div class="form_item_right">   
                                <div class="form_item_label">{{ $t('tenant.check_motor_bit') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_part_permission.check_motor_bit"
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                        </div>
                        <div class="form_item">
                            <div class="form_item_left">
                                <div class="form_item_label">{{ $t('tenant.check_motor_bind_status') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_part_permission.check_motor_bind_status" 
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.triple_id_trans_frame_number') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_part_permission.triple_id_trans_frame_number"
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                        </div>
                        <div class="form_item">
                            <div class="form_item_right">   
                                <div class="form_item_label">{{ $t('tenant.require_new_motor_key') }}<span class="required">*</span></div>
                                <div class="form_item_content">
                                    <a-select 
                                        v-model:value="addFormData.tenant_part_permission.require_new_motor_key"
                                        style="width: 100%" 
                                        :options="selectOptions"
                                    ></a-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 隐私协议 -->
                    <div class="steps_content" v-if="current == 3">   
                        <div class="form_item">
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.privacy_version') }}</div>
                                <div class="form_item_content">
                                    <a-input 
                                        v-model:value="privacy_version"
                                        maxlength="100"
                                        placeholder="2026.1.1"
                                        
                                    />
                                </div>
                            </div>
                            <div class="form_item_center">
                                <div class="form_item_label">{{ $t('tenant.warranty_version') }}</div>
                                <div class="form_item_content">
                                    <a-input 
                                        v-model:value="warranty_version" 
                                        maxlength="100" 
                                        placeholder="2026.1.1"
                                    />
                                </div>
                            </div>
                        </div>

                        <a-button type="primary" size="small" @click="handleAddPolicy">
                            <PlusOutlined />
                            {{ $t('base.add') }}
                        </a-button>

                        <div class="policy_list" v-for="(item, index) in addFormData.tenant_policies" :key="index">
                            <a-tooltip placement="topLeft">
                                <template #title>
                                    <span>{{ $t('base.delete') }}</span>
                                </template>
                                <MinusCircleOutlined style="fontSize:16px; color: red; cursor: pointer;" v-if="addFormData.tenant_policies.length > 1" @click="handleDelPolicy(index)" />
                            </a-tooltip>
                            
                            <div class="form_item">
                                <div class="form_item_left">
                                    <div class="form_item_label">{{ $t('tenant.locale_language') }}<span class="required">*</span></div>
                                    <div class="form_item_content">
                                        <a-select 
                                            v-model:value="item.locale_language" 
                                            style="width: 100%" 
                                            :options="localeLanguageOptions"
                                        ></a-select>
                                    </div>
                                </div>
                                <div class="form_item_center">
                                    <div class="form_item_label">{{ $t('tenant.home_path') }}<span class="required">*</span></div>
                                    <div class="form_item_content">
                                        <a-input v-model:value="item.home_path" maxlength="100" />
                                    </div>
                                </div>
                            </div>
                            <div class="form_item">
                                <div class="form_item_right">
                                    <div class="form_item_label">{{ $t('tenant.support_path') }}<span class="required">*</span></div>
                                    <div class="form_item_content">
                                        <a-input v-model:value="item.support_path" maxlength="100" />
                                    </div>
                                </div>
                                <div class="form_item_left">
                                    <div class="form_item_label">{{ $t('tenant.assemble_path') }}</div>
                                    <div class="form_item_content">
                                        <a-input v-model:value="item.assemble_path" maxlength="100" />
                                    </div>
                                </div>
                            </div>
                            <div class="form_item">
                                <div class="form_item_center">
                                    <div class="form_item_label">{{ $t('tenant.privacy_path') }}<span class="required">*</span></div>
                                    <div class="form_item_content">
                                        <a-input v-model:value="item.privacy_path" maxlength="100" />
                                    </div>
                                </div>
                                <div class="form_item_center">
                                    <div class="form_item_label">{{ $t('tenant.warranty_path') }}<span class="required">*</span></div>
                                    <div class="form_item_content">
                                        <a-input v-model:value="item.warranty_path" maxlength="100" />
                                    </div>
                                </div>
                            </div>
                            <div class="form_item">
                                <div class="form_item_right">
                                    <div class="form_item_label">{{ $t('tenant.fault_can_footer') }}<span class="required">*</span></div>
                                    <div class="form_item_content">
                                        <a-input v-model:value="item.fault_can_footer" maxlength="100" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="steps_action">
                    <a-button v-if="current < steps.length - 1" type="primary" @click="next">{{ $t('base.next') }}</a-button>
                    <a-button v-if="current == steps.length - 1" type="primary" @click="handleSave">{{ $t('base.save')  }}</a-button>
                    <a-button v-if="current > 0" style="margin-left: 8px" @click="prev">{{ $t('base.previous') }}</a-button>
                </div>
            </div>

        </a-modal>
    </div>
</template>

<script setup>
    import { ref, reactive, onMounted, watch, nextTick } from "vue";
    import { message, Modal, notification } from 'ant-design-vue';
    import { useI18n } from 'vue-i18n';
    import { TenantApi } from '@/api/TenantApi.js';
    const { t } = useI18n()

    const props = defineProps({
        visible:{
            type:Boolean,
        },
        isEdit:{
            type:Boolean,
        },
        detailData:{
            type:Object,
            default:()=>{},
        },
    })

    const headers = ref({
        'Authorization': 'Bearer' + sessionStorage.getItem('token'),
    })

    const logoIconList = ref([])
    const smallLogoIconList = ref([])
    const mailHeadIconList = ref([])
    const mailFooterIconList = ref([])
    const selectOptions = ref([
        { value: 0, label: t('base.yes') },
        { value: 1, label: t('base.no') },
    ])
    const localeLanguageOptions = ref([
        { value: 'en_US', label: 'English' },
        { value: 'de_DE', label: 'German' },
        { value: 'fr_FR', label: 'French' },
        { value: 'nl_NL', label: 'Dutch' },
    ])

    const btn_loading = ref(false)
    const current = ref(0)
    const steps = ref([
        { title: t('tenant.tenantInfo'), content: '' },
        { title: t('tenant.mailInfo'), content: '' },
        { title: t('tenant.partPermission'), content: '' },
        { title: t('tenant.policies'), content: '' },
    ])
    const items = steps.value.map(item => ({
        key: item.title,
        title: item.title,
    }))

    const activateMileageOptions = ref([
        { value: 1, label: '75km' },
        { value: 2, label: '100km' },
        { value: 3, label: '125km' },
        { value: 4, label: '150km' },
    ])

    const addFormData = ref({
        tenant:{
            tenant_name:'',
            tenant_code:'',
            app_id:'',
            domain_name:'',
            project_no:'',
            jwt_secret:'',
            picture_path:'',
            file_path:'',
            avatar_path:'',
            vali_user_path:'',
            firmware_path:'',
            del_user_path:'',
            fault_path:'',
            fault_font_color:'',
            fault_background_color:'',
            logo_icon:'',
            small_logo_icon:'',
            activate_mileage_type:75,
            warranty_period:2,
        },
        tenant_mail:{
            mail_host:'',
            mail_port:'',
            mail_protocol:'',
            mail_username:'',
            mail_password:'',
            default_encoding:'',
            mail_debug:'',
            mail_starttls:'',
            mail_ssl:'',
            mail_auth:'',
            mail_head_icon:'',
            mail_footer_icon:'',
        },
        tenant_part_permission:{
            require_hardware_version:'',
            require_software_version:'',
            require_company_id:'',
            require_project_no:'',
            check_display_theft_prevention:'',
            check_motor_bit:'',
            check_motor_bind_status:'',
            triple_id_trans_frame_number:'',
            require_new_motor_key:'',
        },
        tenant_policies:[
            {
                locale_language: '',
                home_path: '',
                support_path: '',
                assemble_path: '',
                privacy_path: '',
                warranty_path: '',
                fault_can_footer: '',
            }
        ],
    })

    const privacy_version = ref('')
    const warranty_version = ref('')

    const emits = defineEmits([
        'handleCancel',
        'handleSave',
    ])

    const init = () => {
        for(let key in addFormData.value){
            if(key != 'tenant_policies'){
                for(let val in addFormData.value[key]){
                    addFormData.value[key][val] = props.detailData[key][val]
                    addFormData.value[key]['id'] = props.detailData[key]['id']
                }
            }else{
                addFormData.value.tenant_policies = props.detailData.tenant_policies
            }
        }

        privacy_version.value = props.detailData.tenant.privacy_version
        warranty_version.value = props.detailData.tenant.warranty_version

        logoIconList.value = [{status:'done', url:props.detailData.tenant.logo_icon}]
        smallLogoIconList.value = [{status:'done', url:props.detailData.tenant.small_logo_icon}]
        if(props.detailData.tenant_mail) mailHeadIconList.value = [{status:'done', url:props.detailData.tenant_mail.mail_head_icon}]
        if(props.detailData.tenant_mail) mailFooterIconList.value = [{status:'done', url:props.detailData.tenant_mail.mail_footer_icon}]
    }


    const next = () => {
        switch(current.value){
            case 0:
                addFormData.value.tenant
                for(let key in addFormData.value.tenant){
                    if(addFormData.value.tenant[key] === '' && key !== 'logo_icon' && key !== 'small_logo_icon'){
                        message.error(t('tenant.' + key) + ' ' + t('base.noEmpty'))
                        return
                    }else if(key === 'logo_icon'){
                        if(logoIconList.value.length === 0){
                            message.error(t('tenant.' + key) + ' ' + t('base.noEmpty'))
                            return
                        }
                    }else if(key === 'small_logo_icon'){
                        if(smallLogoIconList.value.length === 0){
                            message.error(t('tenant.' + key) + ' ' + t('base.noEmpty'))
                            return
                        }
                    }
                }
                break;
            case 1:
                for(let key in addFormData.value.tenant_mail){
                    if(addFormData.value.tenant_mail[key] === '' && key !== 'mail_head_icon' && key !== 'mail_footer_icon'){
                        message.error(t('tenant.' + key) + ' ' + t('base.noEmpty'))
                        return
                    }else if(key === 'mail_head_icon'){
                        if(mailHeadIconList.value.length === 0){
                            message.error(t('tenant.' + key) + ' ' + t('base.noEmpty'))
                            return
                        }
                    }else if(key === 'mail_footer_icon'){
                        if(mailFooterIconList.value.length === 0){
                            message.error(t('tenant.' + key) + ' ' + t('base.noEmpty'))
                            return
                        }
                    }
                }
                break;
            case 2:
                for(let key in addFormData.value.tenant_part_permission){
                    if(addFormData.value.tenant_part_permission[key] === ''){
                        message.error(t('tenant.' + key) + ' ' + t('base.noEmpty'))
                        return
                    }
                }
                break;
        }
        current.value++
    }
    
    const prev = () => {
        current.value--
    }

    // 自定义上传请求，不实际提交到服务器
    const customRequest = (options) => {
        const { file, onSuccess, onError } = options;
        
        // 模拟上传成功，直接调用 onSuccess
        setTimeout(() => {
            onSuccess({ status: 'done' }, file);
        }, 100);
    }

    const uploadChange = async(type, obj) => {
        let form = new FormData()
        form.append('file', obj.file.originFileObj)
        let res = await TenantApi.getInstance().uploadPictures(form)
        if(res.code === 0){
            switch(type){
                case 'logoIcon':
                    addFormData.value.tenant.logo_icon = res.data.download_path
                    break
                case 'smallLogoIcon':
                    addFormData.value.tenant.small_logo_icon = res.data.download_path
                    break
                case 'mailHeadIcon':
                    addFormData.value.tenant_mail.mail_head_icon = res.data.download_path
                    break
                case 'mailFooterIcon':
                    addFormData.value.tenant_mail.mail_footer_icon = res.data.download_path
                    break
            }
        }else{
            message.error(res.msg || t('base.getDataFail'))
        }
    }

    const handleAddPolicy = () => {
        addFormData.value.tenant_policies.push({
            locale_language: '',
            home_path: '',
            support_path: '',
            assemble_path: '',
            privacy_path: '',
            warranty_path: '',
            fault_can_footer: '',
        })
    }

    // 删除隐私协议项
    const handleDelPolicy = (index) => {
        addFormData.value.tenant_policies.splice(index, 1)
    }

    const handleSave = async () => {
        let versionReg = /^(\d{1,4})\.([1-9]\d{0,2})\.([1-9]\d{0,2})$/
        if(privacy_version.value && !versionReg.test(privacy_version.value)){
            message.error(t('tenant.privacy_version_format_error'))
            return
        }else if(warranty_version.value && !versionReg.test(warranty_version.value)){
            message.error(t('tenant.warranty_version_format_error'))
            return
        }

        for(let i = 0; i < addFormData.value.tenant_policies.length; i++){
            let item = addFormData.value.tenant_policies[i]
            for(let key in item){
                if(item[key] === '' && key !== 'assemble_path'){
                    message.error(t('tenant.' + key) + ' ' + t('base.noEmpty'))
                    return
                }
            }
        }

        let formData = {...addFormData.value}
        formData.tenant.privacy_version = privacy_version.value
        formData.tenant.warranty_version = warranty_version.value

        console.log(formData,'formData')

        let res = !props.isEdit? await TenantApi.getInstance().saveTenant(formData)
                : await TenantApi.getInstance().updateTenant(formData)
        if(res.code === 0){
            message.success(t('base.saveSuccess'))     
            emits('handleSave')
        }else{
            message.error(res.msg || t('base.getDataFail'))
        }
    }

    const handleCancel = () => {
        resetForm()
        emits('handleCancel')
    }

    const resetForm = () => {
        addFormData.value = {
            tenant:{
                tenant_name:'',
                tenant_code:'',
                app_id:'',
                domain_name:'',
                project_no:'',
                jwt_secret:'',
                picture_path:'',
                file_path:'',
                avatar_path:'',
                vali_user_path:'',
                firmware_path:'',
                del_user_path:'',
                fault_path:'',
                fault_font_color:'',
                fault_background_color:'',
                logo_icon:'',
                small_logo_icon:'',
                activate_mileage_type:75,
                warranty_period:2,
            },
            tenant_mail:{
                mail_host:'',
                mail_port:'',
                mail_protocol:'',
                mail_username:'',
                mail_password:'',
                default_encoding:'',
                mail_debug:'',
                mail_starttls:'',
                mail_ssl:'',
                mail_auth:'',
                mail_head_icon:'',
                mail_footer_icon:'',
            },
            tenant_part_permission:{
                require_hardware_version:'',
                require_software_version:'',
                require_company_id:'',
                require_project_no:'',
                check_display_theft_prevention:'',
                check_motor_bit:'',
                check_motor_bind_status:'',
                triple_id_trans_frame_number:'',
                require_new_motor_key:'',
            },
            tenant_policies:[
                {
                    locale_language: '',
                    home_path: '',
                    support_path: '',
                    assemble_path: '',
                    privacy_path: '',
                    warranty_path: '',
                    fault_can_footer: '',
                }
            ],
        };
        privacy_version.value = ''
        warranty_version.value = ''
       
        logoIconList.value = []
        smallLogoIconList.value = []
        mailHeadIconList.value = []
        mailFooterIconList.value = []
    }


    watch(()=>props.visible, (newVal) => {
        current.value = 0
        resetForm()
        if(newVal && props.isEdit) init()
    })


    defineExpose({
        addFormData
    })

    onMounted(()=>{
      
    })
</script>

<style lang="scss" scoped>
.steps_container{
    padding: 20px 30px;
}
.steps_content{
    margin-top: 30px;
    .form_item{
        display: flex;
        margin-bottom: 10px;

        .form_item_left{
            flex: 1;
            margin-right: 10px;
        }
        .form_item_center{
            flex: 1;
            margin-right: 10px;
        }
        .form_item_right{
            flex: 1;
            margin-right: 10px;
        }

        .form_item_label{
            .required{
                color: red;
            }
        }
    }


    .policy_list{
        margin-top: 30px;
        border: 1px solid #f0f0f0;
        border-radius: 5px;
        padding: 10px;
        background: #f5f5f5;

    }
}

.steps_action{
    margin-top: 30px;
    text-align: center;
}
.steps_content_container{
    height: 550px;
    overflow-y: scroll;
}
</style>